import { ArticleCategoryEnum } from "../enums/ArticleCategory";

export const printArticleCategory = (articleCategoryInt: number) => {
    return ArticleCategoryEnum[articleCategoryInt];
};